import { connect } from 'react-redux';

import { updateOrgType } from 'redux/ItemPageSlice';

import LegacyOrganisationPanel from './LegacyOrganisationPanel';

interface OrganisationTypeProperties {
  longClickCheck: any;
  isLongClicked: boolean;
  refetchRequest: () => void;
  orgChartType: number;
  updateOrg: (type: number) => void;
}

const OrganisationType = ({
  longClickCheck,
  isLongClicked,
  refetchRequest,
  orgChartType,
  updateOrg,
}: OrganisationTypeProperties) => (
  <LegacyOrganisationPanel
    longClickCheck={longClickCheck}
    isLongClicked={isLongClicked}
    refetchRequest={refetchRequest}
    orgChartType={orgChartType}
    updateOrg={updateOrg}
  />
);

const stateToProperty = (state: any) => ({
  orgChartType: state.itemPageSlice.orgChartType,
});

const mapDispatchToProperties = (dispatch: any) => ({
  updateOrg: (data: number) => dispatch(updateOrgType(data)),
});

export default connect(stateToProperty, mapDispatchToProperties)(OrganisationType);
